module.exports = __webpack_public_path__ + "static/img/3.4d6d0bae.png";